export const GET_CORPORATES_REQUEST = "BULK/GET_CORPORATES_REQUEST"; 
export const GET_CORPORATES_SUCCESS = "BULK/GET_CORPORATES_SUCCESS"; 
export const GET_CORPORATES_FAILURE = "BULK/GET_CORPORATES_FAILURE"; 

export const DOWNLOAD_TEMPLATE_REQUEST = "BULK/DOWNLOAD_TEMPLATE_REQUEST"; 
export const DOWNLOAD_TEMPLATE_SUCCESS = "BULK/DOWNLOAD_TEMPLATE_SUCCESS";
export const DOWNLOAD_TEMPLATE_FAILURE = "BULK/DOWNLOAD_TEMPLATE_FAILURE";

export const BULK_UPLOAD_REQUEST = "BULK/BULK_UPLOAD_REQUEST";
export const BULK_UPLOAD_SUCCESS = "BULK/BULK_UPLOAD_SUCCESS";
export const BULK_UPLOAD_FAILURE = "BULK/BULK_UPLOAD_FAILURE";

export const RESET_BULK_UPLOAD = "BULK/RESET_BULK_UPLOAD";